export default "__VITE_ASSET__4TM$KOSm__"